import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText"; 
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugEliglustat} from "./TextDrugEliglustat"


export default function Eliglustat() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
    
    <ButtonsText onClick={handleOpen} name='Eliglustat' size='large' color='common.white'   />
   
    <CustomDialog open={open} onClose={handleClose}

        title="Eliglustat- PGx Recommendation"
        content={ <TextDrugEliglustat />}

        />

</>
)}